<template>
  <div class="top flex-column">
    <div class="info flex-column">
      <!-- 广告图(主图) -->
      <div class="adv" :style="{ height: advs.banner.length > 0 ? 'auto': '92px' }">
        <MySwiper :swipers="advs.banner" radius="5px" :dotShow="false" />
      </div>
      <div class="tips flex-column">
        <div>GLOBE/TM 查话费发送1到222,查流量发送DATABAL到8080,或*143#拨号</div>
        <div>SMART/TNT/SUN 查话费流量*123#拨号出去，选择BAL</div>
        <div>DITO查话费流量，发送HELP到185</div>
        <div>批量充值、订单问题、套餐咨询可联系人工客服</div>
      </div>
      <!-- 生活缴费/批量充值 -->
      <div class="list flex-row">
        <div v-if="advs.life[0]" class="item" @click="link(advs.life[0].url)">
          <img :src="advs.life[0].pic" />
        </div>
        <div v-if="advs.batch[0]" class="item" @click="link(advs.batch[0].url)">
          <img :src="advs.batch[0].pic" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MySwiper from '@/components/swiper.vue'

  export default {
    components: {
      MySwiper
    },
    props: {
      advs: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {

      }
    },
    methods: {
      link(url) {
        const authToken = localStorage.getItem('auth_token')
        if (!authToken) {
          this.$message({
            message: "请先登录！",
            type: "warning"
          })
          return
        }
        if (!url) return
        this.$router.push(url)
      }
    }
  }
</script>

<style lang="less" scoped>
  .top {
    text-align: left;
    background: url('../../../static/images/round.png') no-repeat;
    background-size: cover;
    background-position: bottom;
    background-color: transparent;
    .top-bg {
      width: 100%;
      height: auto;
    }
    .info {
      width: 100%;
      position: relative;
      padding: 4px;
      z-index: 9;
      background-color: transparent;

      .tips {
        font-size: 13px;
        margin: 9px 0;
        color: #fff;
        line-height: 24px;
      }
      .adv {
        border-radius: 5px;
      }
      .list {
        width: 100%;
        padding: 0 !important;
        .item {
          width: calc((100% - 4px) / 2);
          // height: 42px;
          margin-right: 4px;
          background: #fff;
          border-radius: 5px;
          box-shadow: 2px 4px 8px -1px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          margin-bottom: 0 !important;
          cursor: pointer;
          padding: 0 !important;
          &:nth-child(2n) {
            margin-right: 0;
          }
          img {
            width: 100%;
            aspect-ratio: 13/3;
            object-fit: cover;
            display: block;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/components/home/top.vue